module.exports = __webpack_public_path__ + "static/img/ranking cursos 768x1024.2ef04d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/capacitador/populares/ranking cursos 768x1024.jpg
// module id = DnPw
// module chunks = 47